module.exports = __webpack_public_path__ + "static/chopperResized-8045c467e427dca843485689ae2a6911.png";